import { LoadingSkeleton } from '@features/contract-validation/components/LoadingSkeleton';
import { DialogTitle } from '@headlessui/react';

const ModalTitleSkeleton = () => {
  return <div className="mr-4 h-6 w-48 animate-pulse rounded-md bg-slate-200" />;
};

const ModalDescriptionSkeleton = () => {
  return (
    <>
      <div className="mr-4 mb-1 h-4 animate-pulse rounded-md bg-slate-200" />
      <div className="mr-4 h-4 w-48 animate-pulse rounded-md bg-slate-200" />
    </>
  );
};

const ModalIconSkeleton = () => {
  return <div className="h-10 w-10 animate-pulse rounded-full bg-slate-200" />;
};

export const ModalContentSkeleton = ({ includeValidationChecks }: { includeValidationChecks: boolean }) => {
  return (
    <>
      <ModalIconSkeleton />
      <div className="mt-3 flex-1 text-center sm:mt-0 sm:ml-4 sm:text-left">
        <DialogTitle as="h3" className="text-info-900 text-lg leading-6 font-medium">
          <ModalTitleSkeleton />
        </DialogTitle>
        <div className="mt-3">
          <ModalDescriptionSkeleton />
          {includeValidationChecks && (
            <div className="mt-8">
              <h3 className="text-info-900 mb-3 text-lg leading-6 font-medium">Contract validation checks</h3>
              <LoadingSkeleton className="pb-4" />
              <hr />
            </div>
          )}
        </div>
      </div>
    </>
  );
};
